import React, { useContext } from "react";
import "./View_Delivery_Boy_Details.css";
import { Form, Modal } from "react-bootstrap";
import Img_modal from "./Img_modal/Img_modal";
import { Context } from "../../../utils/context";

function View_Delivery_Boy_Details({ ...props }) {
  console.log(props?.details, "detailsdetails");

  const [modalShow, setModalShow] = React.useState(false);
  const [image, setimage] = React.useState(false);

  const { IMG_URL } = useContext(Context);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Details_Modal View_Delivery_Boy_Details"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Delivery Boy Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="View_Details">
            <div className="row">
              <div className="col-md-6">
                <Form.Label>First Name</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.first_name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Last Name</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.last_name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Email</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.email}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Contact Number</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.contact_no}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Bank Name</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.delivery_boy_kyc?.bank_name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Account Number</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.delivery_boy_kyc?.account_number}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>IFSC Code</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.delivery_boy_kyc?.ifsc_code}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Vehicle Number</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.vehicle_no}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Vehicle RC Number</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.vehicle_rc_no}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Vehicle Licence Number</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.details?.vehicle_licence_no}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {" "}
                <Form.Label>Profile Image</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.image);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.image}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Label>Aadhar Card</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.aadhar_card);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.aadhar_card}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Label>Pan Card</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.pan_card);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.pan_card}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Label>Driving Licence</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.driving_licence);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.driving_licence}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Label>Vehicle Image</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.vehicle_image);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.vehicle_image}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Label>Vehicle RC Image</Form.Label>
                <div
                  className="document_img_holder"
                  onClick={() => {
                    setModalShow(true);
                    setimage(props?.details?.vehicle_rc_image);
                    // props.onHide();
                  }}
                >
                  <img
                    src={`${IMG_URL}${props?.details?.vehicle_rc_image}`}
                    alt="Profile"
                    className="document_img"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Img_modal
        show={modalShow}
        image={image}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default View_Delivery_Boy_Details;
